import React, { useEffect, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import parse from "html-react-parser";
import TitleBar from "../../../../partials/content/TitleBar";
import Sidebar from "../../../../partials/aside/Sidebar";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";

export default function Edit() {
  const history = useHistory();
  const params = useParams();
  const privateNotificationID = params.privateNotificationID;

  const [text, setText] = useState();
  const [privateNotification, setPrivateNotification] = useState();

  const apiKey = "n0pnn5k9s0m0dsdttkjemajjkwr2ud59f1m3kvan1f8skwc5";
  const pluginsTinyMCEEditor = "lists link";
  const toolBarTinyMCEEditor =
    " undo redo fontsize |  numlist bullist checklist link |  bold italic underline forecolor backcolor | alignleft aligncenter alignright alignjustify lineheight | checklist  indent outdent |  ";

  const bodyStyleTinyMCEEditor = "body {direction: rtl}";

  useEffect(() => {
    getPrivateNotification();
  }, []);

  const getPrivateNotification = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let result = await sendRequestGetPrivateNotification(privateNotificationID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    setPrivateNotification(result);
    setText(result.pno_text);
  };

  const sendRequestGetPrivateNotification = async (privateNotificationID) => {
    const headersRequest = getHeaderForRequest();
    let privateNotification;
    try {
      privateNotification = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/private-notification/manage/" +
          privateNotificationID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return privateNotification.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestEditPrivateNotification = async (
    privateNotificationID,
    data
  ) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/private-notification/manage/" +
          privateNotificationID,
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return true;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let result = await sendRequestEditPrivateNotification(
      privateNotificationID,
      {
        text: text,
        title: document.querySelector("#title").value,
        active: document.querySelector("#active").checked,
      }
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    history.push("/user/notification-private/all");
  };

  const generateForm = () => {
    let isChecked = "";
    if (privateNotification.pno_active) {
      isChecked = "checked";
    }

    return (
      <form onSubmit={sendForm}>
        <div className="form-group">
          <label>عنوان</label>
          <input
            type="text"
            className="form-control"
            id="title"
            placeholder="عنوان"
            defaultValue={privateNotification.pno_title}
            required
          />
        </div>
        <div>
          <h2>متن</h2>
          <div className="form-group">
            <Editor
              apiKey={apiKey}
              initialValue={privateNotification.pno_text}
              onEditorChange={(content) => {
                setText(content);
              }}
              init={{
                custom_undo_redo_levels: false,
                height: 300,
                menubar: false,
                plugins: pluginsTinyMCEEditor,
                toolbar: toolBarTinyMCEEditor,
                content_style: bodyStyleTinyMCEEditor,
                default_link_target: "_blank",
              }}
            />
          </div>
        </div>

        <div className="pt-2 d-flex align-items-center ">
          <span className="pl-2">فعال :</span>
          <span>
            <label className="adl-switch">
              <input
                type="checkbox"
                defaultChecked={isChecked}
                id="active"
                className="permissions"
              />
              <span className="adl-slider round"></span>
            </label>
          </span>
        </div>

        <div>
          <h2>پیش نمایش متن</h2>
          <div>{text && parse(text)}</div>
          <div>
            <button className="btn btn-success">ویرایش</button>
          </div>
        </div>
      </form>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="ویرایش کردن پیام های خصوصی کاربران" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left pb-2">
                <Link
                  className="text-white"
                  to="/user/notification-private/all"
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>
              {privateNotification && generateForm()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
